import { render } from "./EtatMpostBoxPage.vue?vue&type=template&id=fb5d9bf6&ts=true"
import script from "./EtatMpostBoxPage.vue?vue&type=script&lang=ts"
export * from "./EtatMpostBoxPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__